import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { Building2 } from 'lucide-react';
import { getDepartmentDistribution } from '../../../services/dashboardService';
import { Card, CardHeader, CardTitle, EmptyState, ChartWrapper } from '../styles';

const COLORS = ['#0291EF', '#02D3BF', '#7C3AED', '#F97316', '#FF6B6B', '#FFC107', '#06B6D4', '#84CC16', '#EC4899', '#6366F1'];

export default function DepartmentDistributionCard() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    getDepartmentDistribution().then(res => {
      const d = res.data?.data;
      setData(Array.isArray(d) ? d : []);
    });
  }, []);

  return (
    <Card $grow={9} $minWidth="420px" $delay="0.35s">
      <CardHeader>
        <CardTitle>{t('dashboard.departmentDistribution')}</CardTitle>
      </CardHeader>
      {data.length === 0 ? (
        <EmptyState>
          <Building2 size={32} />
          {t('dashboard.noData')}
        </EmptyState>
      ) : (
        <ChartWrapper>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }} layout="vertical">
              <CartesianGrid strokeDasharray="3 3" stroke="#F0F2F5" horizontal={false} />
              <XAxis type="number" tick={{ fontSize: 12 }} allowDecimals={false} />
              <YAxis dataKey="label" type="category" tick={{ fontSize: 11 }} width={100} />
              <Tooltip
                contentStyle={{ borderRadius: 6, border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', fontSize: 13 }}
              />
              <Bar dataKey="value" name={t('dashboard.employees')} radius={[0, 4, 4, 0]} barSize={20}>
                {data.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </ChartWrapper>
      )}
    </Card>
  );
}
